export default {
  checkedInLink: {
    textDecoration: 'underline',
    cursor: 'pointer',
    padding: '0.3rem',
  },
  separator: {
    padding: '0 .3rem',
  },
}
